import FlatCard from "components/UI-lib/FlatCard";
import { PermissionHierarchyType } from "models/Permission.model";
import React, { act, useContext, useEffect, useMemo, useState } from "react";
import { BarList } from "../../../Graphs/BarList";
import {
  ArrowPathIcon,
  BanknotesIcon,
  CpuChipIcon,
  EyeIcon,
  RectangleGroupIcon,
  RectangleStackIcon,
  RocketLaunchIcon,
  Square3Stack3DIcon,
  WrenchScrewdriverIcon,
} from "@heroicons/react/24/outline";
import PortsIcon from "assets/img/svg/ports.svg?react";
import { GitHubLogoIcon } from "@radix-ui/react-icons";

const LaunchableFlyWheel: React.FC = () => {
  const [dotPosition, setDotPosition] = useState({ x: 0, y: 0 });
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => (prev >= 1 ? 0 : prev + 0.002));
    }, 16);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // Calculate the position of the dot along the path
    const calculatePosition = () => {
      const pathLength = 4; // 4 segments in our square
      const segment = Math.floor(progress * pathLength);
      const segmentProgress = (progress * pathLength) % 1;

      // Card positions (relative to container)
      const positions = [
        { x: 0, y: 0 }, // Top-left
        { x: 1, y: 0 }, // Top-right
        { x: 1, y: 1 }, // Bottom-right
        { x: 0, y: 1 }, // Bottom-left
      ];

      const start = positions[segment % 4];
      const end = positions[(segment + 1) % 4];

      return {
        x: start.x + (end.x - start.x) * segmentProgress,
        y: start.y + (end.y - start.y) * segmentProgress,
      };
    };

    setDotPosition(calculatePosition());
  }, [progress]);

  return (
    <div className="flex flex-col relative w-full">
      <div className="flex grid grid-cols-2 gap-6">
        <FlatCard className="w-full">
          <div className="flex flex-col">
            <div className="flex flex-row justify-center">
              <CpuChipIcon className="h-5 w-5 text-white mr-1" />
              <h1>Compute</h1>
            </div>
          </div>
        </FlatCard>
        <FlatCard className="w-full">
          <div className="flex flex-col">
            <div className="flex flex-row justify-center">
              <Square3Stack3DIcon className="h-5 w-5 text-white mr-1" />
              <h1>Containers</h1>
            </div>
          </div>
        </FlatCard>
        <FlatCard className="w-full">
          <div className="flex flex-col">
            <div className="flex flex-row justify-center">
              <GitHubLogoIcon className="h-5 w-5 text-white mr-1" />
              <h1>Resources</h1>
            </div>
          </div>
        </FlatCard>
        <FlatCard className="w-full">
          <div className="flex flex-col">
            <div className="flex flex-row justify-center">
              <PortsIcon className="h-6 w-6 text-white mr-1" />
              <h1>Networking</h1>
            </div>
          </div>
        </FlatCard>
      </div>

      {/* SVG for the connecting lines */}
      <svg
        className="absolute top-0 left-0 w-full h-full pointer-events-none"
        style={{ zIndex: -1 }}
        preserveAspectRatio="none"
      >
        {/* Top horizontal line */}
        <line
          x1="25%"
          y1="25%"
          x2="75%"
          y2="25%"
          stroke="#262626"
          strokeWidth="2"
        />

        {/* Right vertical line */}
        <line
          x1="75%"
          y1="25%"
          x2="75%"
          y2="75%"
          stroke="#262626"
          strokeWidth="2"
        />

        {/* Bottom horizontal line */}
        <line
          x1="75%"
          y1="75%"
          x2="25%"
          y2="75%"
          stroke="#262626"
          strokeWidth="2"
        />

        {/* Left vertical line */}
        <line
          x1="25%"
          y1="75%"
          x2="25%"
          y2="25%"
          stroke="#262626"
          strokeWidth="2"
        />

        {/* Animated green dot */}
        <circle
          cx={`${25 + dotPosition.x * 50}%`}
          cy={`${25 + dotPosition.y * 50}%`}
          r="6"
          fill="#76B900"
          filter="drop-shadow(0 0 5px #10b981)"
        />
      </svg>
    </div>
  );
};

export default LaunchableFlyWheel;
